
export class LocationListItem {
    locationId: number = 0;
    locationCode: string = '';
    locationName: string = '';
    address: string = '';
    city: string = '';
    state: string = '';
    customerId: number = 0;
    customerName: string = '';
    deliveryTerm: string = '';
    openLoads: string = '';
    originNotes: string = '';
    destinationNotes: string = '';
}